export const INIT_MSG = 'personMsgPage/INIT_MSG';
const initialState = {
    educationOption:[  {
        "v": "小学及以下",
        "k": 1
    },
        {
            "v": "初中",
            "k": 2
        },
        {
            "v": "高中及中专",
            "k": 3
        },
        {
            "v": "大专",
            "k": 4
        },
        {
            "v": "本科",
            "k": 5
        },
        {
            "v": "硕士",
            "k": 6
        },
        {
            "v": "博士",
            "k": 7
        }],
    oldPhone:'',
};

export default (state = initialState, action) => {
    switch (action.type) {
        case INIT_MSG:
            return {
                ...state,
                oldPhone: action.data.oldPhone,
            };

        default:
            return state
    }
}

export const dispatch_func = {
    initMsg : (data) => {
        return dispatch => {
            dispatch({
                type: INIT_MSG,
                data:data
            });
        }
    },


};


// WEBPACK FOOTER //
// ./src/modules/personMsgPage.js